import BaseApi from "./Api";
import { User } from "../types/user";
import { GuestPlayerInputs } from "types/player";

class UserApi extends BaseApi {
  url = "users";
  constructor() {
    super();
    this.setResourceUrl(this.url);
  }

  updateMe = (userInfo: any) => {
    let data = new FormData();
    if (userInfo.title) data.append("title", userInfo.title);
    if (userInfo.name) data.append("name", userInfo.name);
    if (userInfo.lastName) data.append("lastName", userInfo.lastName);
    if (userInfo.dob) data.append("dob", userInfo.dob.toString());
    if (userInfo.gender) data.append("gender", userInfo.gender);
    if (userInfo.cdh) data.append("cdh", userInfo.cdh ?? "");
    if (userInfo.postalCode) data.append("postalCode", userInfo.postalCode);
    if (userInfo.socialHcp) data.append("socialHcp", userInfo.socialHcp);
    if (userInfo.image) data.append("image", userInfo.image);
    if (userInfo.hcp) data.append("hcp", userInfo.hcp?.toString() ?? "0");
    if (userInfo.email) data.append("email", userInfo.email.toString());
    if (userInfo.username) data.append("username", userInfo.username.toString());
    if (userInfo.homeClub) data.append("homeClub", JSON.stringify(userInfo.homeClub));

    return this.instance({
      method: "put",
      url: `${this.url}/`,
      data,
    });
  };

  update = (userId: string, userInfo: User) => {
    const data = new FormData();
    // Helper to append if value is not undefined/null/empty string
    const appendIfValid = (key: string, value: any) => {
      if (value !== undefined && value !== null && value !== "") {
        data.append(key, value);
      }
    };

    appendIfValid("title", userInfo.title);
    appendIfValid("name", userInfo.name);
    appendIfValid("lastName", userInfo.lastName);
    appendIfValid("dob", userInfo.dob ? userInfo.dob.toString() : undefined);
    appendIfValid("gender", userInfo.gender);
    appendIfValid("cdh", userInfo.cdh?.toString());
    appendIfValid("avatar", userInfo.avatar);
    appendIfValid("postalCode", userInfo.postalCode);
    appendIfValid("socialHcp", userInfo.socialHcp?.toString());
    appendIfValid("hcp", userInfo.hcp?.toString());
    appendIfValid("email", userInfo.email?.toString());
    appendIfValid("username", userInfo.username?.toString());
    appendIfValid("homeClub", userInfo.homeClub ? JSON.stringify(userInfo.homeClub) : undefined);
    appendIfValid("club", userInfo.club ? JSON.stringify(userInfo.club) : undefined);
    appendIfValid("rule", userInfo.rule);
    if ("active" in userInfo) data.append("active", `${userInfo.active}`);
    if ("canAddUser" in userInfo) data.append("canAddUser", `${userInfo.canAddUser}`);
    if ("rhiCreatorAllowed" in userInfo) data.append("rhiCreatorAllowed", `${userInfo.rhiCreatorAllowed}`);

    return this.instance({
      method: "put",
      url: `${this.url}/${userId}`,
      data,
    });
  };

  getClubPlayers = (page: number, limit: number, filter?: any, sort?: string, dir?: string, query?: string) => {
    let url = `${this.url}/club/players?page=${page}&limit=${limit}`;
    if (sort) {
      if (dir) {
        url += `&sort=${sort}:${dir}`;
      } else {
        url += `&sort=${sort}:asc`;
      }
    }
    if (query) {
      url += `&query=${query}`;
    }
    if (filter) {
      url += `&filter=${JSON.stringify(filter)}`;
    }
    return this.instance({
      method: "get",
      url,
    });
  };

  updateHcp = (id: string, hcp: number) => {
    return this.instance({
      method: "patch",
      url: `${this.url}/${id}`,
      data: { hcp },
    });
  };

  updateGuest = (id: string, data: GuestPlayerInputs) => {
    return this.instance({
      method: "patch",
      url: `${this.url}/${id}/update-guest`,
      data,
    });
  };
}

export default new UserApi();
